jQuery(document).ready(function( $ ) {

    // contact form script
    var $group_tags = $('.wpforms-form .list-of-procedures select').find('option[value="group-start"]');

    $group_tags.each(function(i, e) {
        var label = $(e).text();
        $(e).nextUntil($group_tags).wrapAll('<optgroup label="'+label+'" />');
        $(e).remove();
    });

    // fix for empty elementor columns which only have background image
    // and no content to maintain height on mobile, it add extra class to
    // spacer widget to maintain height on small screens
    $('.elementor-element-populated').each(function() {

        let $count = $(this).find('.elementor-widget-wrap').children('div').length;
        if ( $count < 2 ) {
            if ( $(this).css('background-image') !== 'none' ) {
                $(this).find('.elementor-spacer-inner').addClass('dummy-spacer');
            }
        }
    });

});